module.exports = __webpack_public_path__ + "static/img/header5.08f0a3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header5.jpg
// module id = r2t2
// module chunks = 1